import { configureStore, combineReducers } from '@reduxjs/toolkit';
// import logger from "../middleware/logger";
// import localStorage from "../middleware/localStorage";
import warehouseContact from './warehouseContact';
import historyOrders from './historyOrders';
import informations from './informations';
import orderDetails from './orderDetails';
import warehouses from './warehouses';
import orderItems from './orderItems';
import warehouse from './warehouse';
import logOrders from './logOrders';
import accounts from './accounts';
import vehicles from './vehicles';
import account from './account';
import orders from './orders';
import popup from './popup';
import auth from './auth';
import user from './user';

const reducer = combineReducers({
  warehouseContact,
  historyOrders,
  orderDetails,
  informations,
  warehouses,
  orderItems,
  warehouse,
  logOrders,
  accounts,
  vehicles,
  account,
  orders,
  popup,
  auth,
  user,
});

// const middleware = (getDefaultMiddleware) =>
//   getDefaultMiddleware().concat(localStorage);

const store = configureStore({
  // middleware,
  reducer,
  devTools: process.env.REACT_APP_MODE === 'dev',
});

export default store;
